// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AC-z","response":"BC-z","error":"CC-z","disabled":"DC-z","buttons":"EC-z","feedbackQuestionSection":"FC-z","yesNoWrapper":"GC-z"};